import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import clsx from "clsx/lite";

const PaymentIcons = ({ data, settings }) => (
	<div className={clsx("flex flex-row w-full",
		settings ? "lg:w-3/4" : "lg:flex-wrap lg:justify-evenly justify-center lg:w-3/4"
	)}>
		{data?.map((icon) => (
			<Link key={icon._key} to={icon?.url}>
				<div className={`${settings ? "h-5.5 w-8 my-4 mx-1.5" : "h-5.5 w-8 lg:w-1/6 my-4 mx-1.5"}`}>
					<Image className="max-h-5.5" image={icon} alt={icon?.alt} />
				</div>
			</Link>
		))}
	</div>
);

export default PaymentIcons;